// Section2.jsx

import React, { useEffect, useState } from "react";
import BlogCard from "../../componets/BlogCard";

const API =
  "https://mean3.com/backend/api/blogs.php";

export default function Section2() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(`${API}?t=${Date.now()}`);

        const result = await response.json();

        if (result.success) {
          setBlogs(result.blogs);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div className="w-full Section2 py-[35px] bg-[#F5F5F5]">
      <div className="container-1280 section2-container relative w-full md:w-[750px] lg:w-[970px] xl:w-[100%] md:px-[15px] mx-auto">
        <h1 className="text-center text-[24px] md:text-[34px] font-bold text-[#DA2128] leading-10">
          Mean3 Blogs
        </h1>

        <div className="flex flex-wrap w-full justify-center xl:justify-start items-center py-[35px]">
          {loading ? (
            <div className="w-full text-center py-10">
              <p>Loading blogs...</p>
            </div>
          ) : blogs.length === 0 ? (
            <div className="w-full text-center py-10">
              <p>No blogs available.</p>
            </div>
          ) : (
            blogs.map((blog) => (
              <BlogCard key={blog.id} blog={blog} />
            ))
          )}
        </div>
      </div>
    </div>
  );
}